<app-page-content [enableMenuButton]="true">
  <span pagetitle>Avviksårsaker</span>

  <div pagecontent>
    <app-deviation-definition-table *ngIf="!coreConfiguration.isMobile" [definitions]="definitions" (editDefinition)="editDefinition($event)"></app-deviation-definition-table>

    <app-list *ngIf="coreConfiguration.isMobile">
      <app-deviation-defintion-item *ngFor="let item of definitions" [deviationDefinition]="item" (click)="editDefinition(item)"></app-deviation-defintion-item>
    </app-list>
  </div>

  <div [style.display]="coreConfiguration.isMobile ? 'block' : 'flex'" pagefooter>
    <app-button-box>
      <button mat-raised-button color="primary" (click)="newDefinition()">NY AVVIKSÅRSAK</button>
    </app-button-box>
  </div>
</app-page-content>

